import type {
  ContentStudioCourseType,
  ContentStudioStatus,
} from "../types";

/** Status groups, in tab order. */
export const CONTENT_STUDIO_STATUSES: readonly ContentStudioStatus[] = [
  "draft",
  "published",
  "unpublished",
  "archived",
];

export const CONTENT_STUDIO_COURSE_TYPES: readonly ContentStudioCourseType[] = [
  "curriculum",
  "generic",
  "competitive",
];

export const DEFAULT_CONTENT_STUDIO_STATUS: ContentStudioStatus = "draft";

/** Radix Select cannot hold "", so "All" uses this sentinel in the UI only. */
export const ALL_OPTION_VALUE = "all";

export const COURSE_LIST_PAGE_SIZE = 10;

/** Poll the draft list every 1 minute to pick up background status changes. */
export const DRAFT_POLL_INTERVAL_MS = 1 * 60 * 1000;

export function isContentStudioStatus(
  value: unknown,
): value is ContentStudioStatus {
  return (
    typeof value === "string" &&
    (CONTENT_STUDIO_STATUSES as readonly string[]).includes(value)
  );
}

export function isContentStudioCourseType(
  value: unknown,
): value is ContentStudioCourseType {
  return (
    typeof value === "string" &&
    (CONTENT_STUDIO_COURSE_TYPES as readonly string[]).includes(value)
  );
}
